import React from 'react';
import PropTypes from 'prop-types';
import FacebookProvider, { Page } from 'react-facebook';
import { Timeline } from 'react-twitter-widgets';

import { ColouredCard } from 'inside-out/components/shared/cards/colouredCard';

import { rightSectionStyle } from './styles';

import { burnedOrange } from 'inside-out/global-styles';

export const CommonSidebar = () => (
	<aside>
		<div className={rightSectionStyle}>
			<h1>Latest Tweets</h1>
			<Timeline
				dataSource={{
					sourceType: 'profile',
					screenName: 'InsideOutInst',
				}}
				options={{
					chrome: 'noheader nofooter',
					height: '650',
				}}
			/>
		</div>
		<div className={rightSectionStyle}>
			<h1>Latest Facebook Posts</h1>
			<FacebookProvider appId="1633061216808989">
				<Page
					href="https://www.facebook.com/InsideOutInstitute/"
					tabs="timeline"
					smallHeader
					showFacepile={false}
					hideCTA
					hideCover
					width={230}
					height={382}
				/>
			</FacebookProvider>
		</div>
		<div className={rightSectionStyle}>
			<ColouredCard
				id={0}
				to="/media-office"
				background={burnedOrange}
				minHeight="auto"
				title="In the press"
				body="See what others write about us!"
				arrow={true}
			/>
		</div>
	</aside>
);



// WEBPACK FOOTER //
// ./src/components/news-and-events/commonSidebar/component.js